module.exports = __webpack_public_path__ + "img/big.74071912.jpg";